import React, { useState } from "react";
import Form, { InputText } from "../../../../../components/Form";
import { IProps } from "./interfaces";
import { Wrapper } from "./styles";

const CreateNewChannel = ({ handleCreateChannel }: IProps) => {
    const [name, setName] = useState("");
    const [isFetching, setIsFetching] = useState(false);

    const changeName = ({ target: { value } }: any) => setName(value);
    const submit = async () => {
        if (name.length < 4) return alert("Channel name is too short! Enter minimum 4 characters");
        if (name.length > 20) return alert("Channel name is too long! Enter minimum 20 characters");
        setIsFetching(true);
        setIsFetching(true);
        await handleCreateChannel(name);
        setIsFetching(false);
    };

    return (
        <Wrapper>
            <Form disabled={isFetching}>
                <InputText label="Channel name" value={name} onChange={changeName} />
                <button onClick={submit} type="submit" className="button button--full-width">
                    Create channel
                </button>
            </Form>
        </Wrapper>
    );
}

export default CreateNewChannel;
